<template>
  <section id="advantages" class="team">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="row">
            <div class="col-sm-12 mrgn-md-top">
              <h2 class="title">{{ $t(`offer.advantages.title`) }}</h2>
            </div>
            <div v-for="i in [1,2,3,4,5,6,7]" :key="i" class="col-12 col-md-4 sm-m-top">
              <ul class="feature-style">
                <li>
                  <div class="feature-subtitle">
                    <h3>{{ $t(`offer.advantages.text.${i}.title`) }}</h3>
                  </div>
                  <div>
                    <p>{{ $t(`offer.advantages.text.${i}.text`) }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Advantages'
}
</script>

<style scoped>
@media only screen and (max-width: 768px) {
  .feature-style li {
    margin-bottom: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/offerPage/advantages.vue